import { Toaster as SonnerToaster, type ToasterProps } from 'sonner'
import { useDarkScheme } from '@/hooks/useDarkScheme'

/**
 * Sonner's toaster, light or dark with the page rather than with the device
 * alone: Sonner's own "system" theme would draw dark toasts on a page that
 * stays light for its logo (logbook decision 26).
 */
export function Toaster(props: Omit<ToasterProps, 'theme'>) {
  return <SonnerToaster {...props} theme={useDarkScheme() ? 'dark' : 'light'} />
}
